import { gql } from '@apollo/client';

const MARK_INBOX_MUTATION = gql`
  mutation markInbox($input: MarkInboxInput) {
    markInbox(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MARK_INBOX_MUTATION;
